// source: types/v1/post_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.v1.PostType', null, global);
/**
 * @enum {number}
 */
proto.types.v1.PostType = {
  POST_TYPE_UNSPECIFIED: 0,
  POST_TYPE_NEWS: 1,
  POST_TYPE_ANNOUNCEMENT: 2,
  POST_TYPE_PAGE: 3,
  POST_TYPE_FAQ: 4
};

goog.object.extend(exports, proto.types.v1);
